import React from 'react';
import ReactDOM from 'react-dom/client';
import MarketplaceApp from './MarketplaceApp.jsx';
import './index.css';

// Make sure we have a root element
const rootElement = document.getElementById('marketplace-root');

if (!rootElement) {
  throw new Error('Failed to find the marketplace-root element');
}

// Create React root and render the app
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <MarketplaceApp />
  </React.StrictMode>,
);
